import React from 'react';
import PropTypes from 'prop-types';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';

const OnboardForm = ({ onSubmit, step, onNext, onPrevious, params, steps, skipSlugStep, overrideCopy, primaryProduct }) => (
// const OnboardForm = ({ onSubmit, step, onNext, onPrevious, steps, skipSlugStep, overrideCopy, primaryProduct }) => (
  <div id="unified-onboard-form">
    <div>
      {step === 1 && (
        <Step1 overrideCopy={overrideCopy[0]} onSubmit={onNext} hideShopLink={primaryProduct === 'INVITATIONS' || primaryProduct === 'SAVE_THE_DATE'} />
      )}
      {
        step === 2 && skipSlugStep &&
          (
            <Step2 overrideCopy={overrideCopy[1]} onPrevious={onPrevious} onSubmit={onSubmit} skipSlugStep={skipSlugStep} />
          )
      }
      {
        step === 2 && !skipSlugStep &&
          (
            <Step2 overrideCopy={overrideCopy[1]} onPrevious={onPrevious} onSubmit={onNext} skipSlugStep={skipSlugStep} />
          )
      }
      {
        step === 3 &&
        (
          <Step3 overrideCopy={overrideCopy[2]} onPrevious={onPrevious} onSubmit={onSubmit} params={params} />
        )
      }
    </div>
    <div className="steps">
      {steps.map(s => (
        <div className={`step ${s === step ? 'active' : ''}${s < step ? 'completed' : ''}`} key={s} />
      ))}
    </div>
  </div>
);

OnboardForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  params: PropTypes.shape({}),
  steps: PropTypes.arrayOf(
    PropTypes.number
  ),
  skipSlugStep: PropTypes.bool,
  overrideCopy: PropTypes.arrayOf(PropTypes.shape({})),
  primaryProduct: PropTypes.string
};

export default OnboardForm;



/** WEBPACK FOOTER **
 ** ./src/components/onboard/OnboardForm.jsx
 **/